import configs from 'configs';
import { authHeaders } from 'functions/authHeader';

const apiUrl = configs.beApiUrl;

// eslint-disable-next-line consistent-return
export const sendMessage = async (data) => {
  try {
    const response = await fetch(`${apiUrl}/nba/sendMsgToNbaChat`, {
      method: 'POST',
      headers: await authHeaders(),
      body: JSON.stringify(data),
    });

    if (!response || !response.ok) {
      throw new Error(`Error sending message: ${response ? response.statusText : 'No response received'}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error sending message:', error);
  }
};

// eslint-disable-next-line consistent-return
export const startNbaSession = async (data) => {
  try {
    const response = await fetch(`${apiUrl}/nba/startNbaSession`, {
      method: 'POST',
      headers: await authHeaders(),
      body: JSON.stringify(data),
    });

    if (!response || !response.ok) {
      throw new Error(`Error sending message: ${response ? response.statusText : 'No response received'}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error sending message:', error);
  }
};

/**
 * Updates the user's current NBA state (milestone, step, action) via the backend.
 * @param {object} stateUpdateData - The data containing userWixId and the state fields to update.
 * @param {string} stateUpdateData.userWixId - The Wix ID of the user.
 * @param {string} [stateUpdateData.currentMilestone] - The new milestone name.
 * @param {string} [stateUpdateData.currentStep] - The new step name.
 * @param {string} [stateUpdateData.currentAction] - The new action name.
 * @returns {Promise<any>} - The response from the backend, likely confirming the update or returning the new state.
 */

export const updateNbaState = async (stateUpdateData) => {
  if (!stateUpdateData || !stateUpdateData.userWixId) {
    console.error('updateNbaState error: userWixId is required in stateUpdateData.');
    throw new Error('userWixId is required to update NBA state.');
  }
  if (!stateUpdateData.currentMilestone && !stateUpdateData.currentStep && !stateUpdateData.currentAction) {
    console.error('updateNbaState error: At least one state field (currentMilestone, currentStep, currentAction) is required.');
    throw new Error('At least one state field is required to update NBA state.');
  }

  try {
    const response = await fetch(`${apiUrl}/nba/updateNbaState`, {
      method: 'POST',
      headers: await authHeaders(),
      body: JSON.stringify(stateUpdateData),
    });

    if (!response || !response.ok) {
      const errorText = response ? await response.text() : 'No response received';
      console.error(`Error updating NBA state: ${response ? response.status : 'N/A'} ${errorText}`);
      throw new Error(`Error updating NBA state: ${response ? response.statusText : 'Network error or no response'}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error calling updateNbaState API:', error);
    throw error;
  }
};
